import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconWarning = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0004 2L2.34017 17H19.6607L11.0004 2ZM11.8665 0.500001C11.4816 -0.166666 10.5193 -0.166667 10.1344 0.499999L0.608123 17C0.223223 17.6667 0.704347 18.5 1.47415 18.5H20.5267C21.2965 18.5 21.7776 17.6667 21.3927 17L11.8665 0.500001Z"
        fill="currentColor"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M10 12V5.5H12V12H10Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M10 15V13H12V15H10Z" fill="currentColor" />
    </svg>
  )
}

export default IconWarning
